import { nortadaLogger } from '../../components/common/logger';

const creditTypesMapperToString = (creditType: string): string => {
  const creditTypesTranslation: Record<string, string> = {
    EXTERNAL_BANK_TRANSFER: 'External bank transfer',
    EXTERNAL_BANK_TRANSFER_ACCESS: 'External bank transfer',
    EXTERNAL_BANK_TRANSFER_PROVIDUS: 'External bank transfer',
    MANUAL_CREDIT: 'Manual credit'
  };

  return creditTypesTranslation[creditType] ?? nortadaLogger.critical(`${creditType} is unsupported credit type.`);
};

export default creditTypesMapperToString;
